<template>
  <div>
    <table class="table">
      <thead>
        <slot name="columns">
          <tr>
            <th v-for="column in columns" :key="column.title">
              {{ column.title }}
            </th>
          </tr>
        </slot>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <slot :row="item">
            <td v-for="column in columns" :key="column.title">
              {{ itemValue(item, column.name) }}
            </td>
          </slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "custom-table",
  props: {
    columns: Array,
    data: Array,
  },
  methods: {
    itemValue(item, columnName) {
      return item[columnName];
    },
  },
};
</script>
<style></style>
